import React from "react";
import { Group, Text } from '@mantine/core';

const LabelWithAsterisk = ({
    stateLabel,
    stateLabelSize = 'sm'
}) => {
    return (
        <Group noWrap spacing={0}>
            <Text
                size={stateLabelSize}
            >
                {stateLabel}
            </Text>

            <Text
                size={stateLabelSize}
                sx={(tema) => ({
                    color: tema.colorScheme === 'light' ? tema.colors.red[6] : tema.colors.red[8]
                })}
            >
                &nbsp;*
            </Text>
        </Group>
    )
}

export default LabelWithAsterisk;